import {post} from './httpBase';
//根据id获取订单详情
export function getdispatch(params) {
    return post('/order/shuttle/dispatcherworkbench', params)
}
export function dispatcherList(params) {
    return post('/order/shuttle/dispatcherworking', params)
}
//cancleCity,cancleCityInfo /order/shuttle/orderdetails
export function getdetailes(params) {
    return post('/order/shuttle/orderdetails', params)
}
//发单orderSend
export function orderSend(params) {
    return post('/order/shuttle/sendordertodriver', params)
}
//选择司机
export function pickDriverList(params) {
    return post('/order/shuttle/sendordermatchingdriver', params)
}
//接驳历史
export function pickHistory(params) {
    return post('/order/shuttle/managershuttleorderlist', params)
}
//接驳订单详情
export function workingDetails(params) {
    return post('/order/shuttle/dispatcherworkingdetails', params)
}


// WEBPACK FOOTER //
// ./src/service/pickService.js